<script>
  import _ from 'lodash';
  import axios from 'axios';
  import BaseLpComponent from '../../baseLp/stepGroup/component.vue';

  export default ({
    name: 'v-form-step-group',
    extends: BaseLpComponent,

    methods: {
      nextStepWithoutCover() {
        this.nextStepValidationTrue().then((error) => {

          if (_.has(error, 'form_cr_c1.city_id')) {
            if (!this.showAddressField) {
              document.getElementById('j-addresses').click();
              this.showAddressField = true;
            }
          }
        });
      },
    }
  });
</script>
